import "./controllers"
import "@hotwired/turbo-rails"
import "@rails/activestorage"
// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(registration => {
        console.log('Service Worker registered:', registration);
      })
      .catch(error => {
        console.log('Service Worker registration failed:', error);
      });
  });
}
